export const setSchemeInfo=(data)=>{
    return {
        type: "SET_SCHEME_INFO",
        info: data,
    }
}
export const nullSchemeInfo=()=>{
    return{
        type:"NULL_SCHEME_INFO",
        info: null
    }
}
export const getSchemeInfo=()=>{
    return {
        type: "GET_SCHEME_INFO",
        
    }
}
